import { useEffect, useRef, useState } from 'react';
import { prefersReducedMotion, useInView } from '../hooks';
import { Screen } from '../mock/primitives';
import { useContent } from '../siteContent';

function CountUp({ value, start }: { value: number; start: boolean }) {
  const [shown, setShown] = useState(value);
  const done = useRef(false);
  useEffect(() => {
    if (!start || done.current || prefersReducedMotion()) return;
    done.current = true;
    const began = performance.now(); const duration = 900;
    let frame = 0;
    const step = (now: number) => {
      const t = Math.min(1, (now - began) / duration);
      setShown(Math.round(value * (1 - Math.pow(1 - t, 3))));
      if (t < 1) frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [start, value]);
  return <>{shown}</>;
}

const metrics: [string, number][] = [['اشتراكات فعالة', 214], ['وجبات مصروفة اليوم', 132], ['تنتهي قريبًا', 9], ['اشتراكات منتهية', 37]];
const week = [['السبت', 58], ['الأحد', 71], ['الإثنين', 66], ['الثلاثاء', 74], ['الأربعاء', 69], ['الخميس', 82], ['الجمعة', 40]] as const;
const plans: [string, number, string][] = [['باقة الشهر', 54, 'var(--mx-green)'], ['باقة الأسبوعين', 28, '#7FB89F'], ['باقة الأسبوع', 18, '#C9DDD3']];

export function Reports() {
  const { reports } = useContent();
  const [ref, inView] = useInView<HTMLDivElement>({ threshold: 0.3 });
  if (!reports.visible) return null;
  let offset = 0;
  return <section className="mx-reports" aria-labelledby="reports-title">
    <div className="mx-container">
      <header className="mx-section-head mx-section-head-split">
        <h2 id="reports-title" className="mx-h2"><span>{reports.line1}</span><span>{reports.line2}</span></h2>
        <p className="mx-body">{reports.body}</p>
      </header>
      <div ref={ref} className={`mx-reports-board${inView ? ' is-in' : ''}`}>
        <Screen label="لوحة تقارير ميلنكس: الاشتراكات الفعالة والوجبات المصروفة والصرف خلال الأسبوع والاشتراكات حسب الباقة، والأرقام توضيحية" className="mk-reports">
          <div className="mk-metrics mk-metrics-4">{metrics.map(([label, value]) => <div className="mk-metric" key={label}><small>{label}</small><strong><CountUp value={value} start={inView} /></strong></div>)}</div>
          <div className="mk-grid2 mk-grid-wide">
            <div className="mk-panel"><b className="mk-panel-title">الصرف خلال الأسبوع</b>
              <div className="mk-chart">{week.map(([day, value]) => <span key={day}><i style={{ '--v': value } as React.CSSProperties} /><small>{day}</small></span>)}</div>
            </div>
            <div className="mk-panel"><b className="mk-panel-title">الاشتراكات حسب الباقة</b>
              <div className="mk-donut-wrap">
                <svg className="mk-donut" viewBox="0 0 42 42" aria-hidden="true">{plans.map(([name, share, color]) => { const node = <circle key={name} cx="21" cy="21" r="15.915" fill="none" stroke={color} strokeWidth="6" strokeDasharray={`${share} ${100 - share}`} strokeDashoffset={25 - offset} />; offset += share; return node; })}</svg>
                <ul>{plans.map(([name, share, color]) => <li key={name}><i style={{ background: color }} />{name}<b>{share}%</b></li>)}</ul>
              </div>
            </div>
          </div>
        </Screen>
        <p className="mx-caption">{reports.caption}</p>
      </div>
      <div className="mx-reports-list">
        <ul>{reports.items.map((item, index) => <li key={index}>{item}</li>)}</ul>
        {reports.statement && <p className="mx-statement mx-statement-sm">{reports.statement}</p>}
      </div>
    </div>
  </section>;
}
